export const hasPositiveOutcome = (status) => ['PASSED', 'APPROVED', 'COMPLETED', 'QUALIFIED'].includes(status)

export const affiliateRequirementsPassed = (data) => {
  const { prospect } = data || {}
  return {
    'Background Check': hasPositiveOutcome(prospect?.backgroundCheck?.status),
    'Qualifying Level': hasPositiveOutcome(prospect?.qualifyingLevel?.status)
  }
}

export const associateRequirementsPassed = (data) => {
  const { prospect } = data || {}
  const pat = prospect?.playingAbilityTestStatus
  return {
    ...affiliateRequirementsPassed(data),
    'Player Ability Test (PAT)': !pat?.expired && hasPositiveOutcome(pat?.status)
  }
}

const calculateRequirements = (requirements) => {
  const passedRequirements = Object.values(requirements).filter((requirement) => requirement).length
  const totalRequirements = Object.values(requirements).length
  return `${passedRequirements} of ${totalRequirements}`
}

export default calculateRequirements

export const isAssociateRequirementsMet = (data) => Object.values(associateRequirementsPassed(data)).every(requirement => requirement)
export const isAffiliateRequirementsMet = (data) => Object.values(affiliateRequirementsPassed(data)).every(requirement => requirement)
